module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5u6oM"))).then(() => parcelRequire('5erN3'));